import React, { useMemo } from "react";
import { Card, Typography, Button, Rate, Row, Col, Tag } from "antd";
import { useSelector } from "react-redux";
import { resourceTypes } from "../../utils/CommonFunctions";
import { useHistory } from "react-router-dom";
import Routes from "../../config/Routes";

const { Text, Title } = Typography;

const ResourceCard = (props) => {
  const { id, type, filter, onReset } = props;
  const history = useHistory();
  const resourceType = useMemo(() => resourceTypes[type], [type]);
  const resourceMap = useSelector((state) => state.resources?.resourceMap);
  const mResource = useMemo(() => resourceMap?.[id] || {}, [resourceMap, id]);

  const onClick = (data) => {
    if (filter?.searchActive) {
      history.push(
        `${Routes.meetingReportsDetails}?resourceType=${type}&resourceId=${
          data?._id ?? ""
        }&from=${filter?.from ?? ""}&to=${filter?.to ?? ""}`
      );
    } else {
      history.push(
        `${Routes.meetingReportsDetails}?resourceType=${type}&resourceId=${
          data?._id ?? ""
        }`
      );
    }

    onReset();
  };

  return (
    <Card
      hoverable
      style={{
        borderRadius: 10,
        overflow: "hidden",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      }}
      bodyStyle={{ padding: 0 }}
    >
      <Row gutter={0}>
        {/* Left Image Section */}
        <Col span={8}>
          <div
            style={{
              position: "relative",
              height: 200,
              overflow: "hidden",
            }}
          >
            <img
              src={resourceType?.image}
              alt={mResource?.name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        </Col>

        {/* Middle Info Section */}
        <Col style={{ padding: "15px 15px 0px 15px" }} span={16}>
          <Title level={4} style={{ marginBottom: 4 }}>
            {mResource?.name}
          </Title>
          <Text type="secondary">
            {mResource?.description || "No Descriptions"}
          </Text>
          <div style={{ marginTop: 12 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Text type="secondary">Capacity</Text>
              <Text strong>{mResource?.capacity} people</Text>
            </div>
          </div>

          <div style={{ marginTop: 8 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Text type="secondary">Total Booking</Text>
              <Text strong>{mResource?.booking_data?.total_bookings || 0}</Text>
            </div>
          </div>

          <div style={{ marginTop: 8 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Text type="secondary">Rebooking Count</Text>
              <Text strong>
                {mResource?.booking_data?.rebooking_user_count || 0}
              </Text>
            </div>
          </div>

          <div style={{ marginTop: 8 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Text strong>
                {`Price: ${mResource?.price} £/${
                  resourceType?._id === "meeting_room" ? "hr" : "day"
                }`}
              </Text>
              <Text
                strong
                onClick={() => onClick(mResource)}
                style={{ textDecoration: "underline", color: "#1890ff" }}
              >
                View Details
              </Text>
              {/*<Button onClick={()=>onClick(mResource)} size="small">View Details</Button>*/}
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default ResourceCard;
